export default __webpack_public_path__ + "static/hero-banner-720-91486924ea880f401af82522a68c3ddd.webm";